// Display-only catalog. The backend keeps its own copy with the grep/spec
// details, so ids here must stay in sync with controllers/automation/manifest.json.
const catalog = [
  {
    id: 'vulcan',
    label: 'Wireline',
    shortLabel: 'Wireline',
    sections: [
      {
        id: 'vulcan-form-vulcan-mobility',
        group: 'Form steps — Vulcan flow',
        label: 'Mobility',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Mobility on top of the locked Fibre Internet + Business Wifi defaults and submits.'
      },
      {
        id: 'vulcan-form-vulcan-all-1',
        group: 'Form steps — Vulcan flow',
        label: 'All products',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds every product the Vulcan flow can reach in one order and submits.'
      },
      {
        id: 'vulcan-form-wln-fibre-internet',
        group: 'Form steps — WLN flow',
        label: 'Fibre Internet',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Fibre Internet on its own and submits the order.'
      },
      {
        id: 'vulcan-form-wln-business-wifi',
        group: 'Form steps — WLN flow',
        label: 'Business Wifi',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Business Wifi on its own and submits the order.'
      },
      {
        id: 'vulcan-form-wln-copper-internet',
        group: 'Form steps — WLN flow',
        label: 'Copper Internet',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Copper Internet on its own and submits the order.'
      },
      {
        id: 'vulcan-form-wln-telus-internet-backup',
        group: 'Form steps — WLN flow',
        label: 'TELUS Internet Backup',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds TELUS Internet Backup with its required Fibre Internet prerequisite and submits.'
      },
      {
        id: 'vulcan-form-wln-business-optik-tv',
        group: 'Form steps — WLN flow',
        label: 'Business Optik TV',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Business Optik TV on its own and submits the order.'
      },
      {
        id: 'vulcan-form-wln-office-phone',
        group: 'Form steps — WLN flow',
        label: 'Office Phone',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds Office Phone on its own and submits the order.'
      },
      {
        id: 'vulcan-form-wln-telus-secure-business',
        group: 'Form steps — WLN flow',
        label: 'TELUS Secure Business',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Adds TELUS Secure Business, walks its security configurator, and submits.'
      },
      {
        id: 'vulcan-form-wln-all-1',
        group: 'Form steps — WLN flow',
        label: 'All products (with TELUS Internet Backup)',
        estimatedMs: 600000,
        mutatesData: true,
        description: 'Maximal combination that keeps TELUS Internet Backup, dropping the products that hide it.'
      },
      {
        id: 'vulcan-form-wln-all-2',
        group: 'Form steps — WLN flow',
        label: 'All products (without TELUS Internet Backup)',
        estimatedMs: 600000,
        mutatesData: true,
        description: 'Maximal combination that keeps the backup-hiding products and drops TELUS Internet Backup.'
      },
      {
        id: 'vulcan-dashboard-pagination',
        group: 'Dashboards',
        label: 'Pagination',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Paginates through My Orders then Order Fulfillment Dashboard.'
      },
      {
        id: 'vulcan-dashboard-columns',
        group: 'Dashboards',
        label: 'Column parity',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Compares the column set between My Orders and Order Fulfillment.'
      },
      {
        id: 'vulcan-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies and resets each filter one by one on both dashboards.'
      },
      {
        id: 'vulcan-dashboard-vieworder',
        group: 'Dashboards',
        label: 'View Order',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens a submitted order and scrolls within it.'
      },
      {
        id: 'vulcan-dashboard-export',
        group: 'Dashboards',
        label: 'Export availability',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Checks export is offered on Order Fulfillment but absent on My Orders.'
      }
    ]
  },
  {
    id: 'fully-managed',
    label: 'Fully Managed',
    shortLabel: 'FM',
    sections: [
      {
        id: 'fm-form-its',
        group: 'Form steps — product scenarios',
        label: 'Managed IT Services only',
        estimatedMs: 150000,
        mutatesData: true,
        description: 'Completes the 3-step FM form with only Managed IT Services selected, then submits the order.'
      },
      {
        id: 'fm-form-licensing',
        group: 'Form steps — product scenarios',
        label: 'Managed IT Services + Microsoft Licensing',
        estimatedMs: 165000,
        mutatesData: true,
        description: 'Adds a Microsoft Licensing subscription line via the Add Subscription modal, then submits the order.'
      },
      {
        id: 'fm-form-mdr',
        group: 'Form steps — product scenarios',
        label: 'Managed IT Services + MDR',
        estimatedMs: 165000,
        mutatesData: true,
        description: "Fills Managed Detection & Response's Number Of Users field, then submits the order."
      },
      {
        id: 'fm-form-all',
        group: 'Form steps — product scenarios',
        label: 'All products',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Selects Managed IT Services, Microsoft Licensing and MDR together in one order and submits it.'
      },
      {
        id: 'fm-dashboard-tabs',
        group: 'Dashboards',
        label: 'Tab switching (My Orders / Order Fulfillment / Discount Approval)',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens the dashboard and switches between every tab the current role has access to.'
      },
      {
        id: 'fm-dashboard-pagination',
        group: 'Dashboards',
        label: 'Pagination',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Pages through the order list on each available dashboard tab.'
      },
      {
        id: 'fm-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies and resets each filter (Province, Status, Opened/Completion date) one at a time.'
      },
      {
        id: 'fm-dashboard-vieworder',
        group: 'Dashboards',
        label: 'View Order',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens the View Order modal for a completed order and scrolls through its details.'
      },
      {
        id: 'fm-dashboard-export',
        group: 'Dashboards',
        label: 'Export orders',
        estimatedMs: 90000,
        mutatesData: false,
        description: 'Exports orders from each available tab and checks the downloaded file name.'
      },
      {
        id: 'fm-dashboard-discount-calc',
        group: 'Dashboards',
        label: 'Discount Calculator',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens the Discount Calculator from the Discount Approval Dashboard, when a row is available.'
      },
      {
        id: 'fm-discount',
        group: 'Dashboards',
        label: 'Discount approval round-trip',
        estimatedMs: 90000,
        mutatesData: true,
        description: 'Requests a discount large enough to force Pending-Approval, saves and continues later, approves it from the Discount Approval Dashboard, then resumes the order from My Orders and submits it.'
      }
    ]
  },
  {
    id: 'wireless',
    label: 'Wireless',
    shortLabel: 'WLS',
    sections: [
      {
        id: 'wls-form-mss-issue',
        group: 'Form steps — MSS reason branches',
        label: 'MSS Issue',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Step 1 "MSS Issue" reveals the team selection, then walks the remaining steps and submits.'
      },
      {
        id: 'wls-form-resubmission',
        group: 'Form steps — MSS reason branches',
        label: 'MSS order requiring resubmission',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Step 1 resubmission branch reveals the acknowledgement field, then submits the order.'
      },
      {
        id: 'wls-form-not-eligible',
        group: 'Form steps — MSS reason branches',
        label: 'Order is NOT eligible for MSS',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Step 1 not-eligible branch reveals the reason checklist, then submits the order.'
      },
      {
        id: 'wls-form-activation',
        group: 'Form steps — full order',
        label: 'New Wireless Activation (1 subscriber, BYOD)',
        estimatedMs: 300000,
        mutatesData: true,
        description: 'Walks all 6 steps with a single BYOD subscriber and submits the order.'
      },
      {
        id: 'wls-dashboard-tabs',
        group: 'Dashboards',
        label: 'Tab switching',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Switches between every dashboard tab the current role exposes.'
      },
      {
        id: 'wls-dashboard-pagination',
        group: 'Dashboards',
        label: 'Pagination',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Paginates through My Orders then All Orders.'
      },
      {
        id: 'wls-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies and resets each filter one by one on every visible dashboard.'
      },
      {
        id: 'wls-dashboard-search',
        group: 'Dashboards',
        label: 'Search',
        estimatedMs: 90000,
        mutatesData: false,
        description: 'Searches by Order ID and Legal Business Name on every visible dashboard.'
      },
      {
        id: 'wls-dashboard-export',
        group: 'Dashboards',
        label: 'Export orders',
        estimatedMs: 90000,
        mutatesData: false,
        description: 'Exports orders from My Orders and All Orders.'
      }
    ]
  },
  {
    id: 'cybersecurity',
    label: 'Cybersecurity',
    shortLabel: 'CS',
    sections: [
      {
        id: 'cs-form',
        group: 'Form steps',
        label: 'End-to-end order',
        estimatedMs: 240000,
        mutatesData: true,
        description: 'Walks Steps 1-3 including the CSTable gating and storage-provider exclusivity rules, then submits.'
      },
      {
        id: 'cs-dashboard-pagination',
        group: 'Dashboards',
        label: 'Pagination',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Paginates through My Orders then Order Fulfillment Dashboard.'
      },
      {
        id: 'cs-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies and resets each filter one by one on both dashboards.'
      },
      {
        id: 'cs-dashboard-vieworder',
        group: 'Dashboards',
        label: 'View Order',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens a completed order and scrolls within it.'
      },
      {
        id: 'cs-dashboard-export',
        group: 'Dashboards',
        label: 'Export orders',
        estimatedMs: 90000,
        mutatesData: false,
        description: 'Exports orders when the export control is available.'
      }
    ]
  },
  {
    id: 'ocdr',
    label: 'OCDR',
    shortLabel: 'OCDR',
    sections: [
      {
        id: 'ocdr-form-all-oc',
        group: 'Form steps — product scenarios',
        label: 'Operator Connect + Microsoft Cloud + CallCabinet',
        estimatedMs: 240000,
        mutatesData: true,
        description: 'Selects the full Operator Connect product set and submits the order.'
      },
      {
        id: 'ocdr-form-all-dr',
        group: 'Form steps — product scenarios',
        label: 'Direct Routing + Microsoft Cloud + CallCabinet',
        estimatedMs: 240000,
        mutatesData: true,
        description: 'Selects the full Direct Routing product set and submits the order.'
      },
      {
        id: 'ocdr-form-dr',
        group: 'Form steps — product scenarios',
        label: 'Direct Routing only',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Selects Direct Routing on its own and submits the order.'
      },
      {
        id: 'ocdr-form-oc',
        group: 'Form steps — product scenarios',
        label: 'Operator Connect only',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Selects Operator Connect on its own and submits the order.'
      },
      {
        id: 'ocdr-form-cloud',
        group: 'Form steps — product scenarios',
        label: 'Microsoft Cloud and Related Services only',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Selects Microsoft Cloud and Related Services on its own and submits the order.'
      },
      {
        id: 'ocdr-form-callcabinet',
        group: 'Form steps — product scenarios',
        label: 'CallCabinet Call Recording only',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Selects CallCabinet Call Recording on its own and submits the order.'
      },
      {
        id: 'ocdr-dashboard-pagination',
        group: 'Dashboards',
        label: 'Pagination',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Paginates through My Orders then Order Fulfillment Dashboard.'
      },
      {
        id: 'ocdr-dashboard-columns',
        group: 'Dashboards',
        label: 'Channel column parity',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Checks Order Fulfillment shows a Channel column that My Orders omits.'
      },
      {
        id: 'ocdr-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 180000,
        mutatesData: false,
        description: 'Applies and resets each filter one by one on both dashboards.'
      },
      {
        id: 'ocdr-dashboard-vieworder',
        group: 'Dashboards',
        label: 'View Order',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens an order and scrolls within it.'
      },
      {
        id: 'ocdr-dashboard-approve',
        group: 'Quote approvals',
        label: 'Approve a Pending Approval quote',
        estimatedMs: 90000,
        mutatesData: true,
        description: 'Approves a Pending Approval quote from Order Fulfillment.'
      },
      {
        id: 'ocdr-dashboard-reject',
        group: 'Quote approvals',
        label: 'Reject a Pending Approval quote',
        estimatedMs: 90000,
        mutatesData: true,
        description: 'Rejects a Pending Approval quote from Order Fulfillment.'
      },
      {
        id: 'ocdr-dashboard-myorders-approval-bug',
        group: 'Quote approvals',
        label: 'My Orders approve/reject gap (known bug)',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Pins the known bug where My Orders cannot approve or reject a Pending Approval quote.'
      },
      {
        id: 'ocdr-dashboard-rejected-actions',
        group: 'Quote approvals',
        label: 'Quote Rejected action parity',
        estimatedMs: 90000,
        mutatesData: false,
        description: 'Compares the Quote Rejected actions offered by My Orders and Order Fulfillment.'
      },
      {
        id: 'ocdr-dashboard-no-export',
        group: 'Dashboards',
        label: 'No Export Orders control',
        estimatedMs: 30000,
        mutatesData: false,
        description: 'Confirms neither tab offers an Export Orders control.'
      }
    ]
  },
  {
    id: 'fully-managed-sow',
    label: 'Fully Managed SOW',
    shortLabel: 'FM SOW',
    sections: [
      {
        id: 'fmsow-form-submit',
        group: 'Form steps',
        label: 'Statement of Work → Appendices → Summary',
        estimatedMs: 180000,
        mutatesData: true,
        description: 'Completes Steps 1-3 with valid data and submits the order.'
      },
      {
        id: 'fmsow-dashboard-landing',
        group: 'Dashboards',
        label: 'Landing state',
        estimatedMs: 45000,
        mutatesData: false,
        description: 'Lands on the dashboard and checks it renders a list or the empty state.'
      },
      {
        id: 'fmsow-dashboard-tabs',
        group: 'Dashboards',
        label: 'Tab switching',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Switches between every available tab.'
      },
      {
        id: 'fmsow-dashboard-scroll',
        group: 'Dashboards',
        label: 'Order list scrolling',
        estimatedMs: 45000,
        mutatesData: false,
        description: 'Scrolls the order list up and down.'
      },
      {
        id: 'fmsow-dashboard-filters',
        group: 'Dashboards',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies and resets each filter one by one.'
      },
      {
        id: 'fmsow-dashboard-search',
        group: 'Dashboards',
        label: 'Search and View Order',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Searches the list and opens the View Order modal when a match is available.'
      }
    ]
  },
  {
    id: 'referral',
    label: 'Referral Form',
    shortLabel: 'Referral',
    sections: [
      {
        id: 'referral-form',
        group: 'Form steps',
        label: 'End-to-end referral',
        estimatedMs: 120000,
        mutatesData: true,
        description: 'Completes Steps 1-3, opens the confirmation modal and Cancels once, re-selects Product of Interest/Product (a known app bug clears them on Cancel), then submits'
      }
    ]
  },
  {
    id: 'manage-control',
    label: 'Admin — Manage & Control',
    shortLabel: 'Manage & Control',
    sections: [
      {
        id: 'mc-tabs',
        group: 'Navigation',
        label: 'All 6 tabs reachable',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Opens each of the six Manage Control tabs in turn.'
      },
      {
        id: 'mc-dealerships',
        group: 'Round-trips',
        label: 'Dealerships: add then remove',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Adds a dealership then removes it again.'
      },
      {
        id: 'mc-domains',
        group: 'Round-trips',
        label: 'Domains Whitelist: add then remove',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Adds a whitelisted domain then removes it again.'
      },
      {
        id: 'mc-form-freeze',
        group: 'Round-trips',
        label: 'Form Freeze toggle',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Freezes a form then unfreezes it, restoring the original state.'
      },
      {
        id: 'mc-channels',
        group: 'Round-trips',
        label: 'Channels availability toggle',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Toggles a form-availability switch off then back on for the first channel.'
      },
      {
        id: 'mc-outlets',
        group: 'Round-trips',
        label: 'Outlet IDs availability toggle',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Toggles a form-availability switch off then back on for the first outlet.'
      }
    ]
  },
  {
    id: 'manage-accounts',
    label: 'Admin — Manage Accounts',
    shortLabel: 'Manage Accounts',
    sections: [
      {
        id: 'ma-landing',
        group: 'Read-only',
        label: 'Page reachable with filters and search',
        estimatedMs: 45000,
        mutatesData: false,
        description: 'Opens Manage Accounts and checks the filters and search controls render.'
      },
      {
        id: 'ma-filters',
        group: 'Read-only',
        label: 'Filters',
        estimatedMs: 120000,
        mutatesData: false,
        description: 'Applies then resets every filter category.'
      },
      {
        id: 'ma-search',
        group: 'Read-only',
        label: 'Search',
        estimatedMs: 60000,
        mutatesData: false,
        description: 'Finds a user by email then clears back to the full list.'
      },
      {
        id: 'ma-edit-profile',
        group: 'Profile round-trips',
        label: 'Edit profile',
        estimatedMs: 90000,
        mutatesData: true,
        description: "Updates a profile's Contact Number then restores the original value."
      },
      {
        id: 'ma-enable-disable',
        group: 'Profile round-trips',
        label: 'Enable / Disable',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Toggles a profile off then back on.'
      },
      {
        id: 'ma-delete-restore',
        group: 'Profile round-trips',
        label: 'Delete then restore',
        estimatedMs: 90000,
        mutatesData: true,
        description: 'Deletes a profile then restores it.'
      },
      {
        id: 'ma-approve',
        group: 'Pending approvals',
        label: 'Approve a pending profile',
        estimatedMs: 60000,
        mutatesData: true,
        description: 'Approves a pending-approval profile.'
      },
      {
        id: 'ma-decline',
        group: 'Pending approvals',
        label: 'Decline a pending profile',
        estimatedMs: 90000,
        mutatesData: true,
        description: 'Declines a pending-approval profile then restores it.'
      }
    ]
  },
  {
    id: 'product-catalogue',
    label: 'Product Catalogue Dashboard',
    shortLabel: 'Product Catalogue',
    sections: [
      {
        id: 'pcd-fm',
        group: 'Manage Products',
        label: 'Fully Managed category and service',
        estimatedMs: 120000,
        mutatesData: true,
        description: 'Adds then removes a Managed IT Services category and service.'
      },
      {
        id: 'pcd-wireline',
        group: 'Manage Products',
        label: 'Wireline 2.0 offer',
        estimatedMs: 120000,
        mutatesData: true,
        description: 'Adds then removes a Wireline 2.0 offer.'
      }
    ]
  }
];

export default catalog;
